module.exports = __webpack_public_path__ + "static/assets/9d76e4ccf26072c4bddaa81a765ab08a.mp3";